import React, { useEffect } from 'react';
import Header from '../headerFooter/header';
import HomeFooter from '../homepage/homefooter';
import './Legal.css'; // Updated CSS import

const PrivacyPolicy = () => {
  // Ensure page starts at top when navigated to
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <div className="legal-page-wrapper">
        <div className="legal-doc-container">
          <h1>Privacy Policy</h1>
          <span className="effective-date">Effective Date: August 5, 2025</span>

          <p>
            Satvic Path (“we,” “us,” or “our”) is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website <a href="https://satvicpath.com" target="_blank" rel="noopener noreferrer">satvicpath.com</a> (the “Website”) and use our Services.
          </p>
          <p>
            By using our Website and Services, you acknowledge that you have read, understood, and agreed to the terms of this Privacy Policy.
          </p>

          <h2>1. Information We Collect</h2>
          <p>We may collect information about you in the following ways:</p>
          
          <h4>Personal Data:</h4>
          <p>Information you voluntarily provide when you register, make a purchase, subscribe to our newsletter, or comment on our blog. This may include your name, email address, phone number, and billing/shipping address.</p>

          <h4>Payment Data:</h4>
          <p>When you make a purchase, payment details such as billing address may be collected. We do not store or process full credit/debit card information directly—this is handled securely by our third-party payment processors.</p>

          <h4>Derivative Data:</h4>
          <p>Automatically collected information like IP address, browser type, operating system, access times, and pages visited before and after accessing our site.</p>
          
          <blockquote>
            <p><strong>Note:</strong> While our servers may log this data, we do not use it for personal tracking or marketing.</p>
          </blockquote>
          
          <h4>Cookies and Tracking Technologies:</h4>
          <p>We may use cookies and similar tools to enhance user experience and understand preferences. You can disable cookies through your browser settings.</p>

          <h2>2. How We Use Your Information</h2>
          <p>We use the information we collect to:</p>
          <ul>
            <li>Create and manage your account.</li>
            <li>Process your orders and deliver purchased products and services.</li>
            <li>Send administrative updates (e.g., order confirmations, policy changes).</li>
            <li>Send newsletters and promotional content (you may opt out anytime).</li>
            <li>Improve Website functionality and user experience.</li>
            <li>Detect and prevent fraud or security threats.</li>
            <li>Respond to your comments, inquiries, or customer service requests.</li>
          </ul>

          <h2>3. Disclosure of Your Information</h2>
          <p>We do not sell, rent, or trade your personal data to third parties. We may share your information with service providers that help us operate efficiently, including:</p>
          <ul>
            <li>Payment Gateways (e.g., Razorpay, Stripe)</li>
            <li>Email Marketing Services (e.g., Mailchimp, ConvertKit)</li>
            <li>Analytics Platforms (e.g., Google Analytics)</li>
            <li>Legal Authorities when required by law or valid government request</li>
          </ul>
          <p>All third-party partners are required to uphold data protection standards.</p>

          <h2>4. Data Security</h2>
          <p>We implement reasonable administrative, technical, and physical safeguards to protect your personal information.</p>
          <ul>
            <li>Data is encrypted during transmission using SSL (Secure Sockets Layer) technology.</li>
            <li>Access to your data is restricted to authorized personnel only.</li>
          </ul>
          <blockquote>
            <p>While we strive to use commercially acceptable means to protect your data, no method of transmission over the internet is 100% secure.</p>
          </blockquote>

          <h2>5. Your Rights and Choices</h2>
          <h4>Manage Your Account:</h4>
          <p>You can view, edit, or delete your personal information by logging into your account.</p>
          <h4>Unsubscribe:</h4>
          <p>To stop receiving marketing emails, click the “unsubscribe” link in our emails.</p>
          <h4>Data Access or Deletion:</h4>
          <p>You may request access to, correction of, or deletion of your personal data. We will honor such requests in accordance with applicable laws, unless we are required to retain certain data for legal or contractual obligations.</p>

          <h2>6. Children’s Privacy</h2>
          <p>Our Services are not intended for individuals under the age of 12. We do not knowingly collect personal information from children. If we discover that we have collected data from a child under 12, we will promptly delete it.</p>
          
          <h2>7. Changes to This Privacy Policy</h2>
          <p>We may update this Privacy Policy occasionally. The updated version will be effective as of the revised “Effective Date” and posted on this page. We recommend reviewing this page periodically for the latest information on our data practices.</p>
          
          <h2>8. Contact Us</h2>
          <p>If you have any questions or concerns regarding this Privacy Policy, you may contact our Data Grievance Officer at:</p>
          <p>
            <strong>Satvic Path</strong><br/>
            📧 Email: <strong><a href="mailto:team@satvicpath@gmail.com">team@satvicpath@gmail.com</a></strong><br/>
            📍 Location: Jodhpur, Rajasthan, India
          </p>
        </div>
      </div>
      <HomeFooter />
    </>
  );
};

export default PrivacyPolicy;